import React, { FC } from "react";
import { IImageProps, Image } from "./Image/Image";
import { ISvgIconProps, SvgIcon } from "../../Icons";
import { VideoWidget, IVideoWidgetProps } from "./Video";
import { IAnyParams } from "../../../helpers";

export type TImageData = { type?: "image"; data: IImageProps };
export type TVideoData = { type: "video"; data: IVideoWidgetProps };
export type TSvgComponentData = {
  type: "svg-component";
  data: {
    src: React.ElementType;
  };
};
export type SvgIconType = {
  type: "svg-sprite" | "svg-icon" | "svg-icon-component";
  data: ISvgIconProps;
};

export type CustomMedia = { type: "customMedia"; data: JSX.Element };

export type IMediaBuilderProps = (
  | TImageData
  | TVideoData
  | TSvgComponentData
  | SvgIconType
  | CustomMedia
) &
  IAnyParams;

/** Media builder */
const MediaBuilder: FC<IMediaBuilderProps> = ({
  type = "image",
  data,
  ...rest
}) => {
  if (type === "customMedia") return data as JSX.Element;
  if (type === "image") {
    return <Image {...(data as IImageProps)} {...rest} />;
  }
  if (["svg-sprite", "svg-icon", "svg-icon-component"].indexOf(type) !== -1)
    return (
      <SvgIcon
        isSprite={type === "svg-sprite"}
        {...(data as ISvgIconProps)}
        {...rest}
      />
    );
  if (type === "svg-component") {
    const SvgComponent = (data as TSvgComponentData["data"]).src;
    return <SvgComponent {...rest} />;
  }
  if (type === "video")
    return <VideoWidget {...(data as IVideoWidgetProps)} {...rest} />;
  return null;
};

export default MediaBuilder;
